module.exports = __webpack_public_path__ + "media/images/icons/sw-gk-a1afaf267246f8d99dfa58e2e06743d4.svg";